import Vue from "vue";
import url from "./apiurls";
import { store } from "../store/store";

export const cartApis = new Vue({
  methods: {
    insertCart(cartData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.insertCart, cartData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getCartDetails() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.getCartDetails)
          .then(res => {
            const newCart = store.state.cart.cart;
            res.data.forEach(cartData => {
              if (
                !newCart.some(cartD => cartD.course_id === cartData.course_id)
              ) {
                newCart.push(cartData);
              }
            });
            store.dispatch("cart/addToCart", newCart);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
});
